import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./App.css";
import PrinceLogo from './images/Princelogo.png';
import Vivek from './images/Vivek.png';
import vinita from './images/vinita.jpg'
import Sachin from './images/Sachin.jpg'
const PrevArrow = ({ onClick }) => (
  <div className="arrow prev-arrow" onClick={onClick}>
    &#8592;
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="arrow next-arrow" onClick={onClick}>
    &#8594;
  </div>
);

function Teammember() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const data = [
    {
      name: `Prince`,
      img: PrinceLogo,
      review: `Full Stack Webdeveloper`
    },
    {
      name: `Vivek`,
      img: Vivek,
      review: `Full Stack Webdeveloper`
    },
    {
      name: `vinita`,
      img: vinita,
      review: `Full Stack Webdeveloper`
    },
    {
      name: `Sachin`,
      img: Sachin,
      review: `Full Stack Webdeveloper`
    },
    // {
    //   name: `Mia Williams`,
    //   img: PrinceLogo,
    //   review: `Lorem ipsum dolor sit amet...`
    // },
  ];

  return (
    <div className="slider-container">
      <h2 className="team-heading">Our Team Members</h2>
      <div className="slider-wrapper">
        <Slider {...settings}>
          {data.map((d, index) => (
            <div key={index} className="card">
              <div className="card-img-container">
                <img src={d.img} alt={d.name} className="card-img" />
              </div>
              <div className="card-content">
                <p className="card-name">{d.name}</p>
                <p className="card-review">{d.review}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Teammember;
